export const APP_PAGES = ['home', 'reading', 'library', 'history', 'settings', 'login'] as const;

export const REST_ROUTES = {
  session: '/session',
  draw: '/draw',
  interpret: '/interpret',
  history: '/history',
  historySave: '/history/save',
  memory: '/memory',
  settings: '/settings',
  llmHealth: '/llm/health',
  llmModels: '/llm/models',
  llmGenerate: '/llm/generate',
} as const;
